<!--
 * @Description: 报名成功信息页
 * @Author: 山淑兰
 * @Date: 2019-11-11 17:39:20
 * @LastEditTime: 2020-07-15 18:03:43
 * @LastEditors: 山淑兰
 -->
<template>
	<div id="signUpInfo">
		<Loading v-if="show"></Loading>
		<div class="signUpInfo_container">
			<div class="nav" v-if="navShow">
				<a :href="navhomeUrl" target="_top">首页</a>
				> <a>照片直播</a>
			</div>
			<div class="banner-img">
				<img :src="meetingInfo.MobileBannerImage" v-if="meetingInfo.MobileBannerImage!=null&&red!='im'">
				<div class="nav-bar">
					<div class="nav-bar-num">
						<img src="../../assets/photo.png">{{photoDetail.photonums}}
					</div>
					<div class="navs" @click="goBack()">
						<img src="../../assets/home.png">
						返回主页
					</div>
				</div>
			</div>
			<div class="signUpInfo_content">
				<div id="meeting_info" class="commonW">
					<div class="meeting-cname">
						{{photoDetail.cname}}
					</div>
					<div v-if="photoDetail.Photos!=null && photoDetail.Photos.length>0">
						<div class="schedule-meeting">
							<div class="meeting-list" v-for="(item,index) in photoDetail.Photos" :key='index'
								@click="bigImg(index)">
								<img :src="item.oimage">
							</div>
						</div>
					</div>
					<div class="noDate" v-else>
						暂无图片
					</div>
				</div>
				<div class="loading" v-if="loading">
					<van-loading type="spinner" color="#fff" vertical size="30px" text-size="14px">加载中...</van-loading>
				</div>
			</div>
		</div>
		<div class="gotop" @click="goTopFun()" v-if="btnFlag">
			<img src="../../assets/goTop.png">
		</div>
		<Footer :footInfo="this.footInfo"></Footer>
		<div class="pop-ups" v-show="popShow">
			<div class="pop-colse" @click="closePup">
				<img src="../../assets/close.png">
			</div>
			<div class="pop-main">
				<swiper ref="mySwiper" :options="swiperOptions">
					<swiper-slide v-for="(item,index) in photoDetail.Photos" :key='index'>
						<div class="swiper-zoom-container">
							<img :src="item.oimage" v-if="!item.disable">
							<img :src="item.redimage" v-if="item.disable">
						</div>
					</swiper-slide>
				</swiper>
			</div>
			<div class="pop-foot">
				<div class="pop-btn">
					<span>{{nowNumber}}</span>/<span>{{photoDetail.photonums}}</span>
				</div>
				<div class="pop-btn" @click="getMore()">
					{{getMoreText}}
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import Loading from '@components/Loading.vue'
	import Footer from '@components/FooterBlack.vue'
	import publicSignup from '../../lib/signUp.js'
	import wxShare from '../../lib/wxShare.js'
	export default {
		name: 'photoDetail',
		components: {
			Footer,
			Loading
		},
		data() {
			return {
				publicSignup: {}, //通用js
				params: {
					m: '',
					clid: '',
				},
				meetingInfo: '',
				show: false,
				loading: false,
				nowPhotoDetail: [],
				photoDetail: '',
				swiperList: [],
				red: '',
				navShow: true,
				navhomeUrl: '',
				popShow: false,
				nowNumber: 1,
				swiperOptions: {
					observer: true,
					observeParents: true,
					initialSlide: 0,
					zoom: true,
				},
				require: true,
				isbottom: 0,
				currentPage: 2,
				getMoreText: '查看原图',
				scrollTop: '',
				btnFlag: false,
				clientHeight: 0, //可视区的高度
				scrollTop: 0, //滚动条滚动时，距离顶部的距离
				scrollHeight: 0, //滚动条的总高度
				footInfo: {
					LogoTxt: '',
					LogoLink: '',
					LogoImg: '',
				},
			}
		},
		computed: {
			swiper() {
				return this.$refs.mySwiper.swiper
			},
		},
		created() {
			this.params = this.$route.query
			this.red = this.params.red
			this.publicSignup = new publicSignup()
			console.log(this.publicSignup)
			let opt = {
				m: this.params.m
			}
			let opts = {
				m: this.params.m,
				clid: this.params.clid
			}
			this.initmeeting(opt)
			this.getPhotoInfo(opts)
		},
		mounted() {
			let that = this
			that.swiper.on("slideChange", function() { //绑定滑块切换事件，异步获取数据
				//console.log(this.swipeDirection)
				var index = this.realIndex;
				//console.log(index)
				if (this.swipeDirection == 'next') {
					if (index >= ((that.currentPage - 1) * 10 - 1) && that.require) {
						that.getPhotoPageInfo()
					}
				}
				that.nowNumber = that.swiper.activeIndex + 1;
				that.photoDetail.Photos[that.nowNumber - 1].disable = false
				that.getMoreText = '查看原图'
			});
			window.addEventListener('scroll', this.handleScroll, true)
		},
		methods: {
			async initmeeting(opt) {
				this.show = true
				this.meetingInfo = await this.publicSignup.init(opt, this)
				if (this.meetingInfo.Code === 1000) {
					this.show = false
					this.footInfo.LogoTxt = this.meetingInfo.LogoTxt
					this.footInfo.LogoLink = this.meetingInfo.LogoLink
					this.footInfo.LogoImg = this.meetingInfo.LogoImg
					if (this.meetingInfo.HomeUrl == null || this.meetingInfo.HomeUrl == '') {
						this.navShow = false
					} else {
						this.navShow = true
						this.navhomeUrl = this.meetingInfo.HomeUrl
					}
				} else {
					this.$notify({
						massage: this.meetingInfo.Msg,
						type: 'danger',
						duration: '3000',
					})
				}
			},
			/**
			 * 初始化报名用户数据
			 */
			async getPhotoInfo(opt) {
				try {
					this.loading = true
					let res = await this.$http.photoInfo(opt)
					console.log(res)
					if (res.Code == 0) {
						this.loading = false
						this.photoDetail = res
						for (let i in this.photoDetail.Photos) {
							this.$set(this.photoDetail.Photos[i], 'disable', false)
						}
						//console.log(this.photoDetail.Photos)
					}
				} catch (err) {
					console.log(err)
				}
			},
			bigImg(index) {
				this.popShow = true
				this.nowNumber = index + 1
				this.swiper.slideTo(index, 0, false);
			},

			closePup() {
				this.popShow = false
			},

			//分页加载
			async getPhotoPageInfo() {
				let that = this
				let opt = {
					m: this.params.m,
					clid: this.params.clid,
					page: this.currentPage,
				}
				try {
					this.loading = true
					let res = await this.$http.photoPageInfo(opt)
					//console.log(res)
					this.loading = false
					this.nowPhotoDetail = res
					if (res.length > 0) {
						that.photoDetail.Photos = that.photoDetail.Photos.concat(res)
						for (let i in that.photoDetail.Photos) {
							that.$set(that.photoDetail.Photos[i], 'disable', false)
						}
						//console.log(that.photoDetail.Photos)
						that.swiper.update()
					}
					if (res.length < 10) {
						that.require = false;
					} else {
						that.currentPage++
					}
					that.$nextTick(() => {
						that.require = true;
						if (that.nowPhotoDetail.length < 10) {
							that.require = false;
							that.isbottom = 1
						}
					})
				} catch (err) {
					console.log(err)
				}
			},
			//滚动加载
			handleScroll(e) {
				let that = this
				let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
				that.scrollTop = scrollTop
				if (that.scrollTop > 100) {
					that.btnFlag = true
				} else {
					that.btnFlag = false
				}
				this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop; //可视区的高度
				this.clientHeight = document.documentElement.clientHeight || document.body.clientHeight; //滚动条滚动时，距离顶部的距离
				this.scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight; //滚动条的总高度
				if (this.scrollTop + this.clientHeight >= this.scrollHeight && this.require) {
					console.log(this.scrollTop, this.clientHeight, this.scrollHeight)
					this.require = false;
					this.isbottom = -1
					//console.log(that.currentPage)
					that.getPhotoPageInfo()
				}
			},

			getMore() {
				this.photoDetail.Photos[this.nowNumber - 1].disable = true
				this.getMoreText = '已加载'
			},

			goBack() {
				this.$router.go(-1);
			},

			goTopFun() {
				let that = this
				let timer = setInterval(() => {
					let ispeed = Math.floor(-that.scrollTop / 5)
					document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
					if (that.scrollTop === 0) {
						clearInterval(timer)
					}
				}, 16)
			},

			//微信分享
			async initShare(title, desc, link, imgUrl) {
				try {
					const headRes = await this.$http.csData({
						url: encodeURIComponent(
							window.location.href.replace(location.hash, '')
						),
					})
					console.log(headRes, 'headRes')
					const _Wx = new wxShare({
						opt: headRes,
					})
					_Wx.ready().then((wx) => {
						_Wx.share(title, desc, link, imgUrl)
						console.log(wx)
					})
					//this.headRess = _Wx
				} catch (err) {
					console.log(err)
				}
			},
		},
	}
</script>
<style lang="scss">
	.payDialog {
		.van-dialog__message {
			font-size: 32px;
			height: 100px;
			line-height: 100px;
		}

		.van-button {
			height: 100px;
			line-height: 100px;
		}

		.van-button__text {
			font-size: 32px;
		}

	}

	.swiper-pagination-bullet {
		width: 14px !important;
		height: 14px !important;
	}
</style>
<style lang="scss" scoped>
	.pop-ups {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		min-height: 100%;
		background: #0a0a0a;
		background-image: url(../../assets/bg_black.png);
		background-size: contain;
		z-index: 500;
		color: #ffffff;

		.pop-colse {
			position: absolute;
			right: 40px;
			top: 40px;
			z-index: 502;
			width: 46px;
			height: 46px;

			img {
				width: 100%;
				height: 100%;
			}
		}

		.pop-main {
			position: absolute;
			left: 0;
			right: 0;
			top: 0;
			bottom: 0;
			z-index: 501;
			display: flex;
			justify-content: center;
			align-items: center;

			.swiper-container {
				width: 100%;
				height: 100%;
			}

			img {
				max-width: 100%;
				max-height: 100%;
			}

			.swiper-zoom-container>img {
				object-fit: initial !important;
			}
		}

		.pop-foot {
			position: absolute;
			right: 40px;
			left: 40px;
			bottom: 40px;
			height: 60px;
			z-index: 502;
			display: flex;
			justify-content: space-between;

			.pop-btn {
				background: rgba(0, 0, 0, .5);
				border: 1px solid hsla(0, 0%, 100%, .2);
				padding: 0 30px;
				font-size: 28px;
				line-height: 58px;
			}
		}
	}


	.signUpInfo-banner {
		width: 100%;
		overflow: hidden;
		position: relative;
	}

	.signUpInfo-banner .swiper-slide {
		position: relative;
		text-align: center;
	}

	.signUpInfo-banner img {
		max-width: 100%;
		display: block;
	}

	.commonW {
		width: 100%;
		margin: 0 auto;
	}

	.meeting-cname {
		font-size: 34px;
		color: #ffffff;
		padding: 30px 20px;
	}

	.meeting-num {
		padding: 0 20px 20px;
		font-size: 26px;
		display: flex;
		color: #ffffff;
		justify-content: space-between;

		>div {
			margin-right: 60px;
			align-items: center;

			img {
				width: 30px;
				height: 25px;
				margin-right: 10px;
			}
		}
	}


	// ----------
	#signUpInfo {
		.signUpInfo_container {
			background: #0a0a0a;
			padding-bottom: 100px;

			.live-data {
				border-top: 1px dashed #e2e8f0;
				display: flex;

				.liveDiv {
					flex: 1;
					text-align: center;
					padding: 20px 0;
					font-size: 26px;

					p {
						color: #1e293b;
						padding: 5px 0;
					}

					p:last-child span {
						font-size: 34px;
						color: #3b82f6;
						font-weight: bold;
					}
				}
			}

			.note {
				text-align: center;
				font-size: 22px;
				color: #64748b;
				margin-top: 20px;
			}

			.pay-btns {
				height: 60px;
				margin-top: 20px;
				border-top: 1px dashed #e2e8f0;
				padding-top: 20px;

				.pay-btn {
					background: linear-gradient(135deg, #3b82f6, #6366f1);
					width: 200px;
					height: 60px;
					text-align: center;
					line-height: 60px;
					color: #ffffff;
					float: right;
					margin-right: 20px;
				}
			}

			.signUpInfo_content {

				.signUpInfo-banner {
					>img {
						width: 100%;
					}
				}
			}
		}

		.van-dialog {
			width: 70%;
			text-align: center;
			font-size: 32px;
			padding-top: 20px;

			.van-dialog__content {
				margin: 20px;
			}

			.van-button {
				font-size: 32px;
				line-height: 60px;
				height: 60px;
			}
		}
	}


	.schedule-meeting {
		display: flex;
		flex-wrap: wrap;
	}

	.meeting-list {
		width: 375px;
		height: 220px;
		border-top: 1px solid #1a1a2e;
		border-right: 1px solid #1a1a2e;
		box-sizing: border-box;

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}

	.meeting-list:nth-child(2n) {
		border-right: none;
	}

	.noDate {
		text-align: center;
		padding: 20px;
		font-size: 26px;
		color: #64748b;
	}


	.nav {
		height: 76px;
		font-size: 26px;
		line-height: 76px;
		background: #0a0a0a url(../../assets/home.png) no-repeat 20px center;
		background-size: 30px 30px;
		color: #ffffff;
		padding: 0 30px 0 60px;

		a {
			color: #ffffff;
		}
	}

	.banner-img {
		position: relative;
		background: #fff;
		min-height: 80px;
	}

	.banner-img img {
		width: 100%;
	}

	.nav-bar {
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 10;
		height: 60px;
		background: rgba(0, 0, 0, .65);
		display: flex;

		.nav-bar-num {
			flex: 1;
			height: 60px;
			display: flex;
			align-items: center;
			color: #ffffff;
			font-size: 26px;

			img {
				width: 30px;
				height: 25px;
				margin-left: 30px;
				margin-right: 10px;
			}
		}
	}

	.navs {
		padding-right: 20px;
		width: 100px;
		height: 80px;
		text-align: center;
		color: #ffffff;
		font-size: 24px;

		img {
			width: 30px;
			height: 30px;
			border: 1px solid rgba(255,255,255,0.3);
			border-radius: 50%;
			padding: 3px;
			display: block;
			margin: -18px auto 0;
		}

		a {
			color: #ffffff;
		}
	}

	#foot {
		position: absolute;
		width: 100%;
		height: 50px;
		text-align: center;
		bottom: 0;
		border-top: 1px solid #e2e8f0;
		background: #f8fafc;
		padding: 10px;
		color: #64748b;
		line-height: 50px;
		margin: 0 auto;
	}

	#foot img {
		display: inline-block;
		vertical-align: top;
		height: 50px;
		margin-right: 10px;
	}

	.gotop {
		position: fixed;
		right: 30px;
		bottom: 40px;
		z-index: 100;
		background: #fff;
		width: 80px;
		height: 80px;
		border-radius: 50%;

		img {
			width: 100%;
			height: 100%;
		}
	}
</style>
